// extracted by mini-css-extract-plugin
module.exports = {"body":"_974daaa","button":"_f732d80"};